// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"ws_a bii_b bii_we"};